<template>
  <a-icon :component="component"></a-icon>
</template>

<script>
export default {
  name: 'UpIcon',
  data () {
    return {
      component: {
        template: `
          <svg viewBox="0 0 1024 1024" width="1em" height="1em"><path d="M392.637878 387.519538h238.680173v636.480462h-238.680173z" p-id="1680" fill="currentColor"></path>
            <path d="M495.270352 7.222462L155.548906 346.943909a23.868017 23.868017 0 0 0 16.707612 41.37123h679.442893a23.868017 23.868017 0 0 0 16.707612-41.37123L529.481177 7.222462a23.868017 23.868017 0 0 0-34.210825 0z" p-id="1681" fill="currentColor"></path>
          </svg>
        `
      }
    }
  }
}
</script>
